/**
 * <s-ship-date> — rewrites its [data-ship-date] element with the date two days from today in the buyer's browser,
 * moved forward to Monday when that lands on a Saturday or Sunday. Format: "Monday, Oct 12th".
 */
class SShipDate extends HTMLElement {
  connectedCallback() {
    const target = this.querySelector('[data-ship-date]');
    if (!target) return;
    const date = new Date();
    date.setDate(date.getDate() + 2);
    const weekday = date.getDay();
    if (weekday === 6) date.setDate(date.getDate() + 2);
    if (weekday === 0) date.setDate(date.getDate() + 1);
    const day = date.getDate();
    const teen = day % 100 >= 11 && day % 100 <= 13;
    const suffix = teen ? 'th' : { 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th';
    const weekdayName = date.toLocaleDateString('en-US', { weekday: 'long' });
    const monthName = date.toLocaleDateString('en-US', { month: 'short' });
    target.textContent = `${weekdayName}, ${monthName} ${day}${suffix}`;
  }
}

if (!customElements.get('s-ship-date')) customElements.define('s-ship-date', SShipDate);
